<div class="msg-container">
  <div class="icon-container">
    <i class="icon icon-triangle-warning"></i>
    <i class="icon icon-circle-info"></i>
    <i class="icon icon-circle-ok"></i>
  </div>
  <span class="fw-bold"
        *ngIf="title()">{{ title() }}: </span>
  {{ message() }}
</div>
